import api from "./api";
import { format } from 'date-fns';


//zone report

export const zoneWiseAttendaceSameDates=async(zoneId, fromDate,toDate)=>{
     const formattedFrom = format(fromDate, 'yyyy-MM-dd');
      const formattedTo = format(toDate, 'yyyy-MM-dd');
     let url=`api/attendance/zone-districtwise-summary?zoneId=${zoneId}&fromDate=${formattedFrom}&toDate=${formattedTo}`
    const response= await api.get(url);
    return  response.data

}
export const zoneWiseAttendaceDifferentDAte=async(zoneId, fromDate,toDate)=>{
     const formattedFrom = format(fromDate, 'yyyy-MM-dd');
      const formattedTo = format(toDate, 'yyyy-MM-dd');
     let url=`api/attendance/zone-summary-by-apm?zoneId=${zoneId}&fromDate=${formattedFrom}&toDate=${formattedTo}`
    const response= await api.get(url);
    return  response.data

}

export const zoneWiseAttendaceDistrictClick=async(districtId, fromDate,toDate)=>{
     const formattedFrom = format(fromDate, 'yyyy-MM-dd');
      const formattedTo = format(toDate, 'yyyy-MM-dd');
     let url=`/api/attendance/district-summary-by-itm?districtId=${districtId}&fromDate=${formattedFrom}&toDate=${formattedTo}`
    const response= await api.get(url);
    return  response.data

}
export const zoneWiseEmployeeLevelByDate = async (districtId, date) => {
  const formattedDate = format(date, "yyyy-MM-dd");
  let url = `/api/attendance/report-by-district?districtId=${districtId}&fromDate=${formattedDate}&toDate=${formattedDate}`;
  const response = await api.get(url);
  return response.data;
};


//pm reports



export const pmWiseAttendaceSameDates=async(fromDate,toDate)=>{
     const formattedFrom = format(fromDate, 'yyyy-MM-dd');
      const formattedTo = format(toDate, 'yyyy-MM-dd');
     let url=`api/attendance/zone-summary?fromDate=${formattedFrom}&toDate=${formattedTo}`
    const response= await api.get(url);
    return  response.data

}


export const pmWiseAttendaceDifferentDAte=async(stateId, fromDate,toDate)=>{
     const formattedFrom = format(fromDate, 'yyyy-MM-dd');
      const formattedTo = format(toDate, 'yyyy-MM-dd');
     let url=`api/attendance/state-summary-by-pm?stateId=${stateId}&fromDate=${formattedFrom}&toDate=${formattedTo}`
    const response= await api.get(url);
    return  response.data

}
